import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LoginGuard } from './@guards/login.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'config',
    loadChildren: () =>
      import('./config/config.module').then((m) => m.ConfigModule),
  },
  {
    path: '',
    loadChildren: () => import('./cms/cms.module').then((m) => m.CMSModule),
    canActivate: [LoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
      useHash: true, // <-- Enable hash routing
      scrollPositionRestoration: 'enabled', // Optional: restore scroll position
      anchorScrolling: 'enabled', // Optional: support anchor links
    }),],
  exports: [RouterModule],
})
export class AppRoutingModule {}
